import React from 'react';
import { DecorativeBorder } from './DecorativeElements';
import { MapPin, Compass, Sun } from 'lucide-react';
export function Location() {
  return <section className="py-20 px-4 bg-paper-texture overflow-hidden" data-id="element-288">
      <div className="max-w-5xl mx-auto" data-id="element-289">
        <div className="text-center mb-12" data-id="element-290">
          <h2 className="text-4xl md:text-5xl text-[var(--brown)] mb-4" data-id="element-291">
            Dove Siamo
          </h2>
          <p className="font-script text-2xl text-[var(--sienna)]" data-id="element-292">
            Where We Are
          </p>
          <DecorativeBorder className="w-48 mx-auto mt-6 text-[var(--sage)]" data-id="element-293" />
        </div>

        <div className="relative bg-[#FDFBF7] p-8 md:p-12 border border-[#E8E1D5] shadow-lg max-w-4xl mx-auto transform rotate-1" data-id="element-294">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-295">

            {/* Testo sinistra */}
            <div className="space-y-6" data-id="element-296">

              <div className="flex items-start gap-4" data-id="element-297">
                <MapPin className="w-8 h-8 text-[var(--sienna)] flex-shrink-0 mt-1" data-id="element-298" />
                <div data-id="element-299">
                  <h3 className="font-serif text-2xl text-[var(--brown)] mb-2" data-id="element-300">
                    Monopoli, Puglia
                  </h3>
                  <p className="text-[var(--brown)] opacity-80 leading-relaxed" data-id="element-301">
                    Situata nella campagna tra ulivi secolari, WaCa Estate si trova a pochi minuti
                    dalle acque cristalline dell’Adriatico e dal centro storico di Monopoli.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-302">
                <Compass className="w-8 h-8 text-[var(--sienna)] flex-shrink-0 mt-1" data-id="element-303" />
                <div data-id="element-304">
                  <h3 className="font-serif text-2xl text-[var(--brown)] mb-2" data-id="element-305">
                    Nei Dintorni
                  </h3>
                  <ul className="space-y-2 text-[var(--brown)] opacity-80" data-id="element-306">
                    <li data-id="element-307">• Polignano a Mare (15 min)</li>
                    <li data-id="element-308">• Alberobello Trulli (25 min)</li>
                    <li data-id="element-309">• Ostuni "Città Bianca" (35 min)</li>
                  </ul>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-310">
                <Sun className="w-8 h-8 text-[var(--sienna)] flex-shrink-0 mt-1" data-id="element-311" />
                <div data-id="element-312">
                  <h3 className="font-serif text-2xl text-[var(--brown)] mb-2" data-id="element-313">
                    Il Territorio
                  </h3>
                  <p className="text-[var(--brown)] opacity-80 leading-relaxed" data-id="element-314">
                    Scopri la Valle d’Itria, assapora la cucina locale e vivi l’autentica
                    ospitalità pugliese tra mare, borghi storici e tramonti dorati.
                  </p>
                </div>
              </div>

            </div>

            {/* Immagine Monopoli */}
            <div className="relative aspect-square rounded-sm overflow-hidden border-2 border-[var(--cream)] shadow-md" data-id="element-315">
              <img src="https://res.cloudinary.com/dfu9nzn8r/image/upload/e_sepia:35,f_auto,q_auto,w_1200/v1771580158/monopoli_p9ioce.jpg" alt="Monopoli centro storico" className="w-full h-full object-cover" loading="lazy" data-id="element-316" />

              {/* Etichetta cartolina */}
              <div className="absolute bottom-4 right-4 bg-[var(--paper)] px-4 py-2 shadow-sm rotate-2" data-id="element-317">
                <span className="font-script text-xl text-[var(--brown)]" data-id="element-318">
                  Monopoli
                </span>
              </div>
            </div>

          </div>

          {/* Timbro decorativo */}
          <div className="absolute top-4 right-4 w-24 h-24 border border-[var(--sienna)] opacity-20 rounded-full flex items-center justify-center transform rotate-12" data-id="element-319">
            <span className="text-xs uppercase tracking-widest text-[var(--sienna)]" data-id="element-320">
              Puglia
            </span>
          </div>

        </div>
      </div>
    </section>;
}